/// <reference path="../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import * as AccountSettingsActions from '../actions/account-settings';
import * as UIActions from '../actions/ui';
import { uiActions } from '@codametrix/ui-common';
import { jumpContext } from '../actions/contexts.action';
import { defaultServiceLine as serviceLineField, defaultOrg as orgField, defaultHomepage as homepageField, demographicsPanel, noDefaultServiceLineOption, noDefaultOrgOption, noDefaultHomepageOption } from '../reducers/state/account-settings';
import { retrieveGroups } from '../core/navigation';
const getHomepageOptions = (activeContext)=>{
    const navOptions = activeContext ? retrieveGroups(activeContext, '*') : [];
    let homepageFieldOptions = [];
    navOptions// TODO: ZEM-690 - remove this filter when we can show provider_directory option for homepage defaults
    .filter((group)=>group.key !== 'provider_directory').forEach((group)=>{
        return group.options.forEach((option)=>{
            if (option.subActions.length > 0) {
                option.subActions.forEach((subAction)=>{
                    if (subAction.enabled) {
                        homepageFieldOptions.push({
                            label: option.label + ': ' + subAction.displayName,
                            path: subAction.path ?? ''
                        });
                    }
                });
            } else {
                if (option.enabled) {
                    homepageFieldOptions.push({
                        label: option.label ?? '',
                        path: option.path
                    });
                }
            }
        });
    });
    return homepageFieldOptions;
};
const updateFieldGroups = (context, defaultOrg)=>{
    const { contexts, activeContext } = context;
    const defaultOrgField = {
        ...orgField,
        options: [
            ...contexts,
            noDefaultOrgOption
        ]
    };
    // Show all service lines as options
    const serviceLineOptions = contexts.map((context)=>context.serviceLines).flat().filter((serviceLine, index, self)=>{
        return self.findIndex((s)=>s.id === serviceLine.id) === index;
    });
    const defaultServiceLineField = {
        ...serviceLineField,
        options: [
            ...serviceLineOptions,
            noDefaultServiceLineOption
        ]
    };
    const homepageFieldOptions = getHomepageOptions(activeContext);
    const defaultHomepageField = {
        ...homepageField,
        options: [
            ...homepageFieldOptions,
            noDefaultHomepageOption
        ]
    };
    const updatedFieldGroup = {
        label: 'Account Defaults',
        fields: [
            defaultOrgField,
            defaultServiceLineField,
            demographicsPanel
        ]
    };
    const selectedOrg = contexts.find((x)=>{
        return x.organizationId === defaultOrg;
    });
    const contextDisplay = selectedOrg?.displayName ?? 'Organization';
    const contextFieldGroup = {
        label: `${contextDisplay} Defaults`,
        fields: [
            defaultHomepageField
        ]
    };
    return [
        updatedFieldGroup,
        contextFieldGroup
    ];
};
const reducer = createReducer(InitialState.accountSettings, (builder)=>{
    builder.addCase(UIActions.logout.type, ()=>({
            ...InitialState.accountSettings
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.accountSettings
        }));
    builder.addCase(AccountSettingsActions.toggleIsOpen, (state, action)=>({
            ...state,
            isOpen: action.payload
        }));
    const updateFormDefinitionHandler = (state, action)=>{
        const payload = action.payload;
        const { defaultOrg } = state.accountDefaults.formObject;
        const fieldGroups = updateFieldGroups(payload, defaultOrg);
        const formDefinition = {
            ...state.accountDefaults.formDefinition,
            fieldGroups
        };
        return {
            ...state,
            accountDefaults: {
                ...state.accountDefaults,
                formDefinition
            }
        };
    };
    builder.addCase(uiActions.chooseContext.type, updateFormDefinitionHandler);
    builder.addCase(AccountSettingsActions.updateFormDefinition, updateFormDefinitionHandler);
    builder.addCase(AccountSettingsActions.saveFormData, (state, action)=>{
        const { defaultOrg, defaultServiceLine, defaultHomepage, demographicsPanelLocation, demographicsPanelVisibility } = action.payload;
        const oldFormObj = state.accountDefaults.formObject;
        const formObject = {
            defaultOrg: defaultOrg ?? oldFormObj.defaultOrg,
            defaultServiceLine: defaultServiceLine ?? oldFormObj.defaultServiceLine,
            defaultHomepage: defaultHomepage?.path.length ? defaultHomepage : oldFormObj.defaultHomepage,
            demographicsPanelLocation: demographicsPanelLocation ?? oldFormObj.demographicsPanelLocation,
            demographicsPanelVisibility: demographicsPanelVisibility ?? oldFormObj.demographicsPanelVisibility
        };
        return {
            ...state,
            accountDefaults: {
                ...state.accountDefaults,
                formObject
            }
        };
    });
});
export default reducer;
